<div>
    <div class="custom-control custom-checkbox" *ngFor="let t of $types">
        <input [checked]="this.value.indexOf(t.value)>-1" (change)="change(t.value)" type="checkbox" [value]="t.value" class="custom-control-input" [id]="'t-'+t.value">
        <label class="custom-control-label" [for]="'t-'+t.value">{{t.name}}</label>
    </div>
</div>
